/**
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Kit 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Navbar.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `name` key is used for the name of the route on the Navbar.
  2. The `icon` key is used for the icon of the route on the Navbar.
  3. The `collapse` key is used for making a collapsible item on the Navbar that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  4. The `route` key is used to store the route location which is used for the react router.
  5. The `href` key is used to store the external links location.
  6. The `component` key is used to store the component of its route.
  7. The `dropdown` key is used to define that the item should open a dropdown for its collapse items .
  8. The `description` key is used to define the description of
          a route under its name.
  9. The `columns` key is used to define that how the content should look inside the dropdown menu as columns,
          you can set the columns amount based on this key.
  10. The `rowsPerColumn` key is used to define that how many rows should be in a column.
*/

import { lazy } from "react";

// @mui material components
import SpartanMark from "components/SpartanMark";

/*
  Les pages sont chargées à la demande : chaque route devient un chunk séparé.
  Toutes les pages importent ce fichier pour la navbar ; des imports statiques
  ici ramèneraient donc l'intégralité du site dans le bundle principal
  (react-markdown, react-syntax-highlighter, gray-matter...).
*/
const Blog = lazy(() => import("layouts/pages/blog"));
const BlogArticle = lazy(() => import("layouts/pages/blog-article"));
const WriteUp = lazy(() => import("layouts/pages/writeup"));
const WriteUpArticle = lazy(() => import("layouts/pages/writeup-article"));
const CVE = lazy(() => import("layouts/pages/cve"));
const CVEArticle = lazy(() => import("layouts/pages/cve-article"));
const Toolbox = lazy(() => import("layouts/pages/toolbox"));

const routes = [

  {
    name: "blog",
    icon: <SpartanMark />,
    description: "Articles & analyses",
    route: "/blog",
    component: <Blog />,
    key: "blog-page",
  },
  {
    name: "write-ups",
    icon: <SpartanMark />,
    description: "CTF & challenges",
    route: "/writeups",
    component: <WriteUp />,
    key: "writeup-page",
  },
  {
    name: "cve",
    icon: <SpartanMark />,
    description: "Vulnérabilités découvertes",
    route: "/cve",
    component: <CVE />,
    key: "cve-page",
  },
  {
    name: "toolbox",
    icon: <SpartanMark />,
    description: "Outils et ressources",
    route: "/toolbox",
    component: <Toolbox />,
    key: "toolbox-page",
  },
  // {
  //   name: "espace membre",
  //   icon: <Icon> </Icon>,
  //   route: "/espace-membre",
  //   component: <EspaceMembre />,
  //   key: "espace-membre",
  // },
];
export const additionalRoutes = [
  {
    route: "/blog/:slug",
    component: <BlogArticle />,
    key: "blog-article-page",
  },
  {
    route: "/writeups/:slug",
    component: <WriteUpArticle />,
    key: "writeup-article-page",
  },
  {
    route: "/cve/:slug",
    component: <CVEArticle />,
    key: "cve-article-page",
  },
];
export default routes;
